import getEnvVar from '@/utils/getEnvVar';

const environment = getEnvVar('MODE');
const isProd = environment === 'production';

type DevMethods = 'warn' | 'log';

export class Logger {
  private static shouldShow() {
    return !isProd;
  }

  private static write(method: 'log' | 'warn' | 'error', label: string, message: string, detail: unknown[]) {
    // eslint-disable-next-line no-console
    console[method](`${label}: ${message}`, ...detail);
  }

  private static logIt(method: DevMethods, moduleName: string, message: string) {
    if (!Logger.shouldShow()) {
      return;
    }
    Logger.write(method, moduleName, message, []);
  }

  static log(moduleName: string, message: string) {
    Logger.logIt('log', moduleName, message);
  }

  static warn(moduleName: string, message: string): void {
    Logger.logIt('warn', `${moduleName} warning`, message);
  }

  static error(moduleName: string, message: string, ...detail: unknown[]): void {
    Logger.write('error', `${moduleName} error`, message, detail);
  }
}
